import React, { useCallback, useState } from 'react';

import { useCheckoutContext } from 'Jsx/CheckoutV4/Context';
import useCustomPayment from 'Jsx/CheckoutV4/hooks/useCustomPayment';

import { EmailState } from '../../UserInputFields/EmailInput';

import QrScreen from './components/QrScreen';
import UserDataStep from './components/UserDataStep';

const Niubiz = () => {
  const { executePayment } = useCustomPayment();

  const { checkoutProductDetail, selectedPaymentMethod } = useCheckoutContext();
  const [qr, setQr] = useState<string>('');
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [email, setEmail] = useState<EmailState>({ email: '', isValid: false });
  const [checkedTerms, setCheckedTerms] = useState<boolean>(true);
  const [checkedNewsLetterTerms, setCheckedNewsLetterTerms] =
    useState<boolean>(false);

  const loadQr = useCallback(() => {
    setIsFirstStep(false);
    if (checkoutProductDetail && selectedPaymentMethod) {
      setLoading(true);
      const { paymentGatewayId } = selectedPaymentMethod;
      const { type: itemType, originalId } = checkoutProductDetail;

      executePayment({
        paymentGateway: `${paymentGatewayId}`,
        itemId: `${originalId}`,
        itemType,
        email: email.email,
      })
        .then(res => {
          if (
            res.data?.payment?.success &&
            res.data.payment.digitalWallet?.tagImg
          )
            setQr(res.data.payment.digitalWallet.tagImg);
        })
        .catch(() => {
          setQr('');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [checkoutProductDetail, executePayment, selectedPaymentMethod, email]);

  return isFirstStep ? (
    <UserDataStep
      onEmailChange={setEmail}
      email={email}
      checkedTerms={checkedTerms}
      onTermsChange={setCheckedTerms}
      newslettersTerms={checkedNewsLetterTerms}
      onNewslettersTermsChange={setCheckedNewsLetterTerms}
      onGenerateQr={loadQr}
    />
  ) : (
    <QrScreen loading={loading} reloadQr={loadQr} qr={qr} />
  );
};

export default Niubiz;
